export var getScrollbarStyles = function getScrollbarStyles(theme, trackBgColor) {
  if (trackBgColor === 'none' || trackBgColor === 'transparent' || trackBgColor === undefined) trackBgColor = theme.palette.common.white;
  return {
    '::-webkit-scrollbar': {
      background: theme.palette.gray[200],
      height: '8px',
      padding: '4px',
      width: '8px'
    },
    '::-webkit-scrollbar-thumb': {
      background: theme.palette.gray[200],
      borderRadius: '8px !important'
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.gray[300]
    },
    '::-webkit-scrollbar-track': {
      background: trackBgColor
    }
  };
};